module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "courseitem"
  }, [_c('img', {
    staticClass: "courseitem_img",
    attrs: {
      "src": require("@/assets/images/mainindex/course-pic@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "courseitem_title"
  }, [_vm._v("啦啦之星教学-街舞啦啦操")]), _vm._v(" "), _c('div', {
    staticClass: "courseitem_desc"
  }, [_c('div', {
    staticClass: "courseitem_desc_person"
  }, [_vm._v("217人学习")]), _vm._v(" "), _c('div', {
    staticClass: "courseitem_desc_money"
  }, [_vm._v("120.00")]), _vm._v(" "), _c('img', {
    staticClass: "courseitem_desc_img",
    attrs: {
      "src": require("@/assets/images/mainindex/icon-free-tag@2x.png")
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32862e3e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainindex/CourseItem.vue
// module id = 1373
// module chunks = 0